import { render, staticRenderFns } from "./ModalProdutividadeCulturas.vue?vue&type=template&id=e0c1f49e&scoped=true&lang=pug"
import script from "./ModalProdutividadeCulturas.vue?vue&type=script&lang=js"
export * from "./ModalProdutividadeCulturas.vue?vue&type=script&lang=js"
import style0 from "./ModalProdutividadeCulturas.vue?vue&type=style&index=0&id=e0c1f49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c1f49e",
  null
  
)

export default component.exports